import React, { useRef } from 'react'
import { AgriProductsAPMC, AmendmentStaffMarketCommittee, AppointmentSecretaryAPMC, BuyingLandAPMC,ContractualAppointmentSecretaryAPMC,PayComission,PermAppointmentSecretaryAPMC,PromotionSecretaryMarketCommittee,ProposalDonation,ProposalLoan,SellingLandAPMC, StudyTour, YardAPMC } from '../Json/AllData';
import CommonSelect, { Option } from './commonSelect';
import { string } from 'yup';
import SingleView from './SingleForm';
import { Link } from 'react-router-dom';

interface Page1Props {
  onNext: () => void;
  onBack: () => void;
  type: string | null;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>,documentName) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,fieldName) =>void;
  formData: Record<string, any>;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  handleSubmit: () => void;
  uploadLoading: boolean;
}


const Page1 = ({
  onNext,
  onBack,
  formData,
  setFormData,
  handleFileChange,
  handleInputChange,
  handleSubmit,
  type,
  uploadLoading
}: Page1Props) => {

  const [errors, setErrors] = React.useState<Record<string, boolean>>({});
  const [showPreview, setShowPreview] = React.useState(false);
  const [selectedDocId, setSelectedDocId] = React.useState<string | null>(null);
  const fieldRefs = useRef<Record<string, HTMLDivElement | null>>({});
const [check,setCheck]= React.useState(false);

  const handlePreviewClick = () => {
    setShowPreview(true);
  };
let heading ="";

  // Handles input and select changes for text, select, radio, percentage

const getDataField = () => {
  const typeNum = Number(type);
  
  switch (typeNum) {
    case 39:
       heading = "Buying";
      return BuyingLandAPMC;
    case 40:
      heading = "Selling Land";
      return SellingLandAPMC;
    case 41:
      heading = "To control Agriculture products under the APMC - Application under Form-8";
      return AgriProductsAPMC;
    case 42:
    heading  ="Declaration of the main yard/sub-yard of APMC";
    return YardAPMC;
    case 43:
      heading = " the new/permanent or temporary appointment of the Secretary in the Market Committee";
      return AppointmentSecretaryAPMC;
    case 44:
      heading = "Permanent appointment of Secretary in the Market Committee";
      return PermAppointmentSecretaryAPMC;
    case 45:
      heading = "Regarding amendment in the staff schedule of the Market Committee";
      return AmendmentStaffMarketCommittee;
      case 46:
        heading = "Regarding promotion from Assistant Secretary / Inspector to Secretary in the Market Committee";
        return PromotionSecretaryMarketCommittee;
    case 47:
      heading = "Regarding contractual appointment of Secretary / employee after retirement";
      return ContractualAppointmentSecretaryAPMC;
    case 48:
      heading ="Regarding approval of 7th Pay Commission for Secretary / employee";
      return PayComission;
    case 49:
      heading = " Proposals regarding donation";
      return ProposalDonation;
    case 50:
      heading = "Proposals regarding loan";
      return ProposalLoan;
    case 51:
      heading = "Approval for Study Tours";
      return StudyTour;
    default:
      return BuyingLandAPMC;
  }
};

  const dataField = getDataField();
  // Handles file input changes


  // --------------------------For Validations--------------------------
const validateField = (fieldName: string, responseVal: string) => {
  const fieldArr = formData[fieldName] || [];
  const item = fieldArr.find((item: any) => item.fieldName === responseVal || item.documentName === responseVal);
  const value = item?.value || item?.docId;

  setErrors(prev => ({
    ...prev,
    [responseVal]: value?.toString().trim() === "",
  }));
};

const validateAllFields = (): boolean => {
  let newErrors: Record<string, boolean> = {};
  let hasError = false;
  let firstErrorField: string | null = null;

  dataField.forEach((fieldItem: any) => {
    fieldItem.response.forEach((responseItem: any) => {
      const fieldName = responseItem.fieldName;
      const responseVal = responseItem.responseVal;

      const fieldArr = formData[fieldName] || [];
      const item = fieldArr.find(
        (item: any) =>
          item.fieldName === responseVal || item.documentName === responseVal
      );
      const value = item?.value || item?.docId;

      if (!value || value.toString().trim() === "") {
        newErrors[responseVal] = true;
        hasError = true;

        if (!firstErrorField) {
          firstErrorField = responseVal;
        }
      }
    });
  });

  setErrors(newErrors);

  // Scroll into view
  if (firstErrorField && fieldRefs.current[firstErrorField]) {
    fieldRefs.current[firstErrorField]?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  return !hasError;
};




  const selectFn = (response:any ) => {
    const options = [
      { value: "option1", label: "Option 1" },
      { value: "option2", label: "Option 2" }
    ];

const handleChange = (selectedOption: Option | null, fieldName: string, responseVal: string) => {
  setFormData(prev => {
    const arr = Array.isArray(prev[fieldName]) ? [...prev[fieldName]] : [];
    const index = arr.findIndex(item => item.fieldName === responseVal);
    if (index !== -1) {
      arr[index] = { ...arr[index], value: selectedOption?.value || "" };
    } else {
      arr.push({ value: selectedOption?.value || "", fieldName: responseVal });
    }
    return { ...prev, [fieldName]: arr };
  });

  validateField(fieldName, responseVal); // <-- add this here
};


    const selectedValue = options.find(opt => opt.value === formData[response?.responseVal]);

    return (

      <CommonSelect
        options={options}
        value={selectedValue}
        name={response?.responseVal}
        onChange={(e) => handleChange(e, response?.fieldName, response?.responseVal)}
        placeholder={`Select ${response?.responseVal}`}
        className={`w-100  ${errors[response?.responseVal] ? 'border border-danger' : ''}`}
        
      />
    );
  };

  const inputFn = (response:any) => {
    return (
      <input
        type="text"
        className={`p-2 form-control  ${errors[response?.responseVal] ? 'border border-danger' : ''}`}
        placeholder={`Enter the value`}
        name={response?.responseVal}
        value={formData[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
        onChange={(e) => {
          handleInputChange(e, response?.fieldName);
          validateField(response?.fieldName, response?.responseVal);
        }}
        onBlur={() => validateField(response?.fieldName, response?.responseVal)}
      />
      
    );
  };
  
  const numberFn = (response:any) => {
    return (
      <input
        type="number"
        className={`p-2 form-control ${errors[response?.responseVal] ? 'border border-danger' : ''}`}
        placeholder={`Enter ${response?.responseVal}`}
        name={response?.responseVal}
        value={formData[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
        onChange={(e) => {
          handleInputChange(e, response?.fieldName);
          validateField(response?.fieldName, response?.responseVal);
        }}
         onBlur={() => validateField(response?.fieldName, response?.responseVal)}
      />
    );
  };

  // Date field support
  const dateFn = (response:any) => {
    return (
        <div className="d-flex flex-column">
      <input
        type="date"
        className={`p-2 form-control ${errors[response?.responseVal] ? 'border border-danger' : ''}`}
        name={response?.responseVal}
        value={formData[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
        onChange={(e) => {
          handleInputChange(e, response?.fieldName);
          validateField(response?.fieldName, response?.responseVal);
        }}
        onBlur={() => validateField(response?.fieldName, response?.responseVal)}
      />
    
      <small className="text-muted mt-1 ms-1">{response.responseName}</small>

      </div>
    );
  };

  const radioFn = (response:any) => (
    <div className="d-flex justify-start gap-2 ">
      <input
        type="radio"
        name={response?.responseVal}
        value="yes"
        checked={formData[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value === "yes"}
                onChange={(e) => {
                  handleInputChange(e, response?.fieldName);
                  validateField(response?.fieldName, response?.responseVal);
                }}
        onBlur={() => validateField(response?.fieldName, response?.responseVal)}
      />{" "}Yes
      <input
        type="radio"
        name={response?.responseVal}
        value="no"
        checked={formData[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value === "no"}
        onChange={(e) => {
          handleInputChange(e, response?.fieldName);
          validateField(response?.fieldName, response?.responseVal);
        }}
        onBlur={() => validateField(response?.fieldName, response?.responseVal)}
      />{" "}No
    </div>
  );

  const percentageFn = (response:any) => (
    <input
      className={`form-control  ${errors[response?.responseVal] ? 'border border-danger' : ''}`}
      type="text"
      inputMode="decimal"
      name={response?.responseVal}
      placeholder="0 - 100"
      value={formData[response?.fieldName]?.find(item=>item.fieldName===response?.responseVal)?.value || ""}
      onChange={(e) => {
        handleInputChange(e, response?.fieldName);
        validateField(response?.fieldName, response?.responseVal);
      }}
      onBlur={() => validateField(response?.fieldName, response?.responseVal)}
    />
  );

const fileFn = (response:any) => (
  <div className="d-flex flex-column w-100">
    <input
      className={`form-control  ${errors[response?.responseVal] ? 'border border-danger' : ''}`}
      type="file"
      onChange={(e) => {
        handleFileChange(e, response?.fieldName);
        validateField(response?.fieldName, response?.responseVal);
      }}
      name={response?.responseVal}
      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
      id={response?.responseVal}
      onBlur={() => validateField(response?.fieldName, response?.responseVal)}
    />
    {(response?.responseVal==='notificationGujarati' || response?.responseVal==="notificationEnglish") && (
      <small className="text-muted mt-1 ms-1">{response.responseName}</small>
    )}
  </div>
);
  const fileButtonFn = (response:any) => {
    const docId= formData[response?.fieldName]?.find(item => item.documentName === response?.responseVal)?.docId || null;

    return (
    <Link
    to="#"
    data-bs-toggle="modal"
    data-inert={true}
    data-bs-target="#apmc_modal"
    className="btn btn-outline-info align-items-center w-75"
    onClick={() => {
      setSelectedDocId(docId);
    
    }}
  >
    <i className="ti ti-eye"></i> View Document
  </Link>
  );
  };

 return (
    <>

     {uploadLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
            <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">Uploading...</span>
              </div>
              <div className="fw-bold">Uploading, please wait...</div>
            </div>
          </div>
        )}
    <div className='w-100 d-flex align-items-end justify-content-end px-5 mt-2'>
      <div className="w-100">
        {/* Change this for selling using props */}
        <h2 className='my-3 mb-4'>Proposal for permission for {heading}</h2>
                <div className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
                  <div id='table' className='w-100 border overflow-hidden bg-white border-secondary rounded mb-5'>
        
                    <div id='head' className='d-flex w-100  rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                        <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                        <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                        <h4 className='col-5 p-2 justify-content-center d-flex align-items-center border-secondary'>જવાબ(Response)</h4>
                    </div>
                    {dataField && dataField.length > 0 &&
                    dataField.map((item,index)=>{
                      return(
                        <>
                          <div className='d-flex  border-top border-secondary'>
                            {/* <h4 className='col-1  d-flex align-items-center justify-content-center'></h4> */}
                              <h4 className='col-1 d-flex align-items-center justify-content-center'>{item.fieldNo}</h4>
                            <div className='col-6 '>
                                <p className='d-flex align-items-center h-100 p-3 border-start border-end border-secondary'>
                                {item.fieldVal}*
                                </p>
                            </div>
                            <div className='col-5 d-flex'>
                              <div className='w-100 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                                {item.response.map((newObj, indx) => {
                                  const fieldName = newObj.responseVal;
                                  const inputKey = `${index}_${indx}`;
                                  const divVal =
                                    newObj.responseType === "select"
                                      ? selectFn(newObj)
                                      : newObj.responseType === "input"
                                      ? inputFn(newObj)
                                      : newObj.responseType === "number"
                                      ? numberFn(newObj)
                                      : newObj.responseType === "date"
                                      ? dateFn(newObj)
                                      : newObj.responseType === "radio"
                                      ? radioFn(newObj)
                                      : newObj.responseType === "percentage"
                                      ? percentageFn(newObj)
                                      : newObj.responseType === "file"
                                      ? (
                                          <div className="d-flex flex-column gap-1">
                                            <div className="d-flex gap-2">
                                              {showPreview && fileButtonFn(newObj)}
                                              {fileFn(newObj)}
                                            </div>
                                            {showPreview && (
                                              <small className="text-muted ms-auto">Re-Upload if Needed</small>
                                            )}
                                          </div>
                                        )
                                      : null;
                                  return (
                                    <div
                                        className="w-75"
                                        key={inputKey}
                                        ref={(el) => {
                                          fieldRefs.current[newObj.responseVal] = el;
                                        }}
                                      >
                                        {divVal}
                                        {errors[newObj.responseVal] && (
                                          <h6 className="text-danger mt-1 mb-0">Required</h6>
                                        )}
                                      </div>

                                  );

                                })}
                              </div>
                            </div>
                          </div>

                        </>
                      )
                    })}
         
                  </div>
                </div>
    <div className='d-flex gap-3 border-secondary border p-3 rounded-2 bg-white mb-2'>
        <div className="pt-2">
            <input
              className="form-check-input "
              type="checkbox"
              name="agreeTerms"
              id="agreeTerms"
              style={{ transform: 'scale(1.5)' }}
              checked={check || false}
              onChange={e => setCheck(e.target.checked)}
            />
          </div>
       <div>
         <p>
            ઉપર મુજબના સામેલ તમામ સાધનિક કાગળો, પ્રમાણપત્રો તથા માહિતીની ચકાસણી / ખરાઈ કરેલ <br/>
            All the above-mentioned supporting documents, certificates, and information have been verified and cross-checked.
        </p>
        {errors.agreeTerms && (
          <div className="text-danger mt-1">Please click the checkbox to submit.</div>
        )}
       </div>
    </div>
        <div className="d-flex justify-content-end gap-2 mb-3">
            {/* <button className="btn btn-secondary" onClick={onBack}>Back</button> */}
            {showPreview===false&&<button className="btn btn-info"             
            onClick={() => {
              const isValid = validateAllFields();
              if (isValid) {
                handlePreviewClick();
              }
            }}>Preview</button>}
            {showPreview && <button className="btn btn-success" 
            onClick={() => {
           
              const isValid = validateAllFields();
                 let hasError = false;
              if (!check) {
                setErrors(prev => ({ ...prev, agreeTerms: true }));
                hasError = true;
              } else {
                setErrors(prev => ({ ...prev, agreeTerms: false }));
              }
              if (isValid && !hasError) {
                handleSubmit();
              }
            }}
              // disabled={!check}
              >Submit</button>}
        </div>
      </div>
      </div>
      <SingleView docId={selectedDocId} type="form" datafield={dataField} />
    </>
  )
}
 
export default Page1